import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrLearningApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    learningDashboard(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrLearningDashboard>> {
        return this.http.get<APIResponseWrapper<HrModels.HrLearningDashboard>>(`${this.baseUrl}/learning/dashboard`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    learningSkills(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrSkill[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrSkill[]>>(`${this.baseUrl}/learning/skills`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveLearningSkill(request: HrModels.HrSkill): Observable<APIResponseWrapper<HrModels.HrSkill>> {
        return request.skillId
          ? this.http.put<APIResponseWrapper<HrModels.HrSkill>>(`${this.baseUrl}/learning/skills/${request.skillId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrSkill>>(`${this.baseUrl}/learning/skills`, request);
      }
    
    learningCourses(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrLearningCourse[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrLearningCourse[]>>(`${this.baseUrl}/learning/courses`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveLearningCourse(request: HrModels.HrLearningCourse): Observable<APIResponseWrapper<HrModels.HrLearningCourse>> {
        return request.courseId
          ? this.http.put<APIResponseWrapper<HrModels.HrLearningCourse>>(`${this.baseUrl}/learning/courses/${request.courseId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrLearningCourse>>(`${this.baseUrl}/learning/courses`, request);
      }
    
    seedLearningDefaults(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrLearningCourse[]>> {
        return this.http.post<APIResponseWrapper<HrModels.HrLearningCourse[]>>(`${this.baseUrl}/learning/courses/defaults`, {}, {
          params: this.params({ owningCompanyId })
        });
      }
    
    employeeSkills(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployeeSkill[]>> {
    
        return this.http.get<APIResponseWrapper<HrModels.HrEmployeeSkill[]>>(`${this.baseUrl}/learning/employee-skills`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveEmployeeSkill(request: HrModels.HrEmployeeSkill): Observable<APIResponseWrapper<HrModels.HrEmployeeSkill>> {
        return request.employeeSkillId
          ? this.http.put<APIResponseWrapper<HrModels.HrEmployeeSkill>>(`${this.baseUrl}/learning/employee-skills/${request.employeeSkillId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrEmployeeSkill>>(`${this.baseUrl}/learning/employee-skills`, request);
      }
    
    learningAssignments(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrLearningAssignment[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrLearningAssignment[]>>(`${this.baseUrl}/learning/assignments`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveLearningAssignment(request: HrModels.HrLearningAssignment): Observable<APIResponseWrapper<HrModels.HrLearningAssignment>> {
        return request.assignmentId
          ? this.http.put<APIResponseWrapper<HrModels.HrLearningAssignment>>(`${this.baseUrl}/learning/assignments/${request.assignmentId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrLearningAssignment>>(`${this.baseUrl}/learning/assignments`, request);
      }
    
    learningCompletions(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrCourseCompletion[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCourseCompletion[]>>(`${this.baseUrl}/learning/completions`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveLearningCompletion(request: HrModels.HrCourseCompletion): Observable<APIResponseWrapper<HrModels.HrCourseCompletion>> {
        return this.http.post<APIResponseWrapper<HrModels.HrCourseCompletion>>(`${this.baseUrl}/learning/completions`, request);
      }
    
    importLearningCompletions(request: HrModels.HrLearningCompletionImportRequest): Observable<APIResponseWrapper<HrModels.HrLearningCompletionImportResult>> {
        return this.http.post<APIResponseWrapper<HrModels.HrLearningCompletionImportResult>>(`${this.baseUrl}/learning/completions/import`, request);
      }
    
    certificateRequirements(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrCertificateRequirement[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCertificateRequirement[]>>(`${this.baseUrl}/learning/certificate-requirements`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveCertificateRequirement(request: HrModels.HrCertificateRequirement): Observable<APIResponseWrapper<HrModels.HrCertificateRequirement>> {
        return request.certificateRequirementId
          ? this.http.put<APIResponseWrapper<HrModels.HrCertificateRequirement>>(`${this.baseUrl}/learning/certificate-requirements/${request.certificateRequirementId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrCertificateRequirement>>(`${this.baseUrl}/learning/certificate-requirements`, request);
      }
    
    learningReadinessImpacts(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrReadinessLearningImpact[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrReadinessLearningImpact[]>>(`${this.baseUrl}/learning/readiness-impacts`, {
          params: this.params({ owningCompanyId })
        });
      }
  };
}
